import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-protocol-control-label-view, [app-protocol-control-label-view]',
  templateUrl: './protocol-control-label-view.component.html',
  styleUrls: ['./protocol-control-label-view.component.scss']
})
export class ProtocolControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
